import * as React from 'react'
import { useActions, useAppSelector } from 'hooks'
import SearchDropdown from 'components/common/SearchDropdown/SearchDropdown'
import { SortOrder } from 'types'

const SortByDropDown: React.FC<{
  defaultOrder?: SortOrder
  width?: number
  index?: number
  height?: number
  handleStateUpdate?: Function
  isTableView?: boolean
}> = ({ width = 220, height = 32 }) => {
  const { setSortOrder } = useActions()
  const { sortBy } = useAppSelector(({ vibrancy }) => vibrancy)
  const sortOrderList = [SortOrder.groupByPillar, SortOrder.overallPosition]
  const handleChangeSortOrder = (event: React.SyntheticEvent, value: any) => {
    setSortOrder(value)
  }

  return (
    <SearchDropdown
      id='grouping-dropdown'
      size='small'
      value={sortBy}
      handleStateUpdate={handleChangeSortOrder}
      data={sortOrderList.map((el) => ({ value: el, isDisabled: false }))}
      width={width}
      height={height}
      fontSize={15}
    />
  )
}
export default SortByDropDown
